// 菁亿用户
import request from '@/utils/request'

// 分页查询
export function list(data) {
  return request({
    url: '/sassa_user/v1/list',
    method: 'post',
    data
  })
}

// 审核数量
export function reviewCnt(data) {
  return request({
    url: '/sassa_user/v1/reviewCnt',
    method: 'get',
    params: data
  })
}

// 新增
export function add(data) {
  return request({
    url: '/sassa_user/v1/add',
    method: 'post',
    data
  })
}

// 冻结/停用
export function stop(data) {
  return request({
    url: '/sassa_user/v1/stop',
    method: 'get',
    params: data
  })
}

// 取消冻结/启用
export function start(data) {
  return request({
    url: '/sassa_user/v1/start',
    method: 'get',
    params: data
  })
}

// 查看单个
export function getById(data) {
  return request({
    url: '/sassa_user/v1/getById',
    method: 'get',
    params: data
  })
}

// 修改
export function update(data) {
  return request({
    url: '/sassa_user/v1/update',
    method: 'post',
    data
  })
}

// 查看用户修改审核信息详情
export function getUserById(data) {
  return request({
    url: '/sassa_review/v1/getUserById',
    method: 'get',
    params: data
  })
}

// 用户信息审核通过
export function agree(data) {
  return request({
    url: '/sassa_review/v1/user/agree',
    method: 'get',
    params: data
  })
}

// 用户信息审核拒绝
export function reject(data) {
  return request({
    url: '/sassa_review/v1/user/reject',
    method: 'post',
    data
  })
}

// 驳回理由 type = 023
export function rejectionType(data) {
  return request({
    url: '/sassa_review/v1/rejectionType',
    method: 'get',
    params: data
  })
}

// 删除用户
export function deleteItem(data) {
  return request({
    url: '/sassa_user/v1/delete',
    method: 'post',
    data
  })
}
